// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-app-header-UserDropdown-module__root--wRlqm","icon":"src-components-app-header-UserDropdown-module__icon--1wbgg"};